import LoadingContext from '../../context/loading-context';
import React from 'react';

// Exports
// -------

export default function useLoadingContext() {
  return React.useContext(LoadingContext);
}
